import React from 'react';

function DashboardSkeleton() {
    return (
        <div className="ecx-page dashboard-page ecx-page--full-width">
            <div className="py-3 py-lg-4 border-bottom bg-light px-4">
                <div className="dashboard-skeleton-card" style={{ width: '18rem', height: '3rem' }} />
            </div>
            <div className="ecx-page-body">
                <div className="dashboard-skeleton-nav" />
                <div className="dashboard-skeleton-charts mb-4">
                    {Array.from({ length: 4 }).map((_, index) => (
                        <div key={`chart-${index}`} className="dashboard-skeleton-chart" />
                    ))}
                </div>
                <div className="dashboard-skeleton-grid mb-4">
                    {Array.from({ length: 10 }).map((_, index) => (
                        <div key={`kpi-${index}`} className="dashboard-skeleton-card" />
                    ))}
                </div>
                <div className="row g-3">
                    {Array.from({ length: 6 }).map((_, index) => (
                        <div key={`section-${index}`} className="col-12 col-xl-6">
                            <div className="dashboard-skeleton-section" />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default DashboardSkeleton;
